import axios, { authAxios } from '@/axios/axios';
import { getActionPinConfig } from '@/helpers';

export const getActionPinValidity = async actionPin => {
    const { data } = await axios.get("users/check-action-pin/", getActionPinConfig(actionPin));
    return data;
}

export const getUsers = async () => {
    const { data } = await authAxios.get("users/");
    return data;
}

export const getUser = async id => {
    const { data } = await authAxios.get(`users/${id}/`);
    return data;
}

export const postUser = async user => {
    const { data } = await authAxios.post(`users/`, user);
    return data;
}

export const patchUser = async user => {
    const { data } = await authAxios.patch(`users/${user?.id}/`, user);
    return data;
}

export const deleteUser = async id => {
    const { data } = await authAxios.delete(`users/${id}/`);
    return data;
}

export const postClearUserTokens = async id => {
    const { data } = await authAxios.post(`users/${id}/clear-tokens/`);
    return data;
}

export const postGenerateUserPassword = async id => {
    const { data } = await authAxios.post(`users/${id}/generate-password/`);
    return data;
}


// WEBPACK FOOTER //
// ./src/queries/users/requests.js